<template>
  <div class="accept-container">
    <div class="title">
      欢迎您使用大会智能推荐服务，为了保证服务质量，您的请求信息会被记录，如您希望了解更多关于数据主体权利、信息安全措施等详细信息，请阅读
      <span class="cs" @click="toPrivacy">《隐私保护》</span>
    </div>
    <div class="tips">
      您在使用过程中，也可前往《隐私保护》的1.2.(3) 退订此服务
    </div>
    <div class="accept flex justify-start align-center">
      <div
        class="checkbox flex justify-center align-center cs"
        v-show="checked"
        @click="changeChecked"
      >
        <div class="dot"></div>
      </div>
      <img
        class="un-checked cs"
        src="../../assets/images/recommend/un-checked.png"
        v-show="!checked"
        @click="changeChecked"
      />
      <p class="agree-pc">
        我已阅读并同意<span class="cs" @click="toPrivacy">《隐私保护》</span
        >的内容
      </p>
      <p class="agree-mobile">
        我已阅读并同意<br /><span @click="toPrivacy">《隐私保护》</span>的内容
      </p>
    </div>
    <div class="btn-box flex justify-center">
      <div
        class="cancel-btn flex justify-center align-center cs"
        @click="cancelAccept"
      >
        取消
      </div>
      <div
        :class="{ disabled: !checked }"
        class="accept-btn flex justify-center align-center cs"
        @click="setAccept"
      >
        开始体验
      </div>
    </div>
  </div>
</template>

<script>
import Cookie from "js-cookie";

export default {
  name: "acceptDialog",
  props: {
    dialogType: {
      type: String,
      default: "agenda",
    },
  },
  data() {
    return {
      checked: Cookie.get("accept_recommend") === 1,
    };
  },
  mounted() {
    this.checked = Cookie.get("accept_recommend") === 1;
  },
  methods: {
    changeChecked(bool) {
      this.checked = !this.checked;
    },
    toPrivacy() {
      let routeUrl = this.$router.resolve({
        path: "/privacy",
      });
      window.open(routeUrl.href, "_blank");
    },
    setAccept() {
      //埋码
      window._hw("send", "action", "index_privacy_policy_click");
      if (this.checked) {
        this.$emit("setAccept", 1);
      }
    },
    cancelAccept() {
      //埋码
      window._hw("send", "action", "index_privacy_policy_closed");
      this.$emit("setAccept", 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.agree-pc {
  display: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.agree-mobile {
  display: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.disabled {
  color: #ffffff !important;
  background: #b2bfc6 !important;
  cursor: not-allowed;
}

@media (min-width: 992px) {
  .accept-container {
    padding: 60px 70px;
    background: #ffffff url("../../assets/images/recommend/leftbg.png")
      no-repeat left bottom;
    background-size: 300px 200px;
    z-index: $z-index-foot;
    position: absolute;
    top: 0;
    right: 88px;
    width: 1000px;
    height: 310px;
    opacity: 1;
    border: 1px solid;
    border-image: linear-gradient(
        164deg,
        rgba(239, 239, 239, 1),
        rgba(235, 235, 235, 0)
      )
      1 1;
    filter: blur(undefinedpx);
    font-size: 16px;

    .agree-pc {
      display: block;
    }

    .title {
      font-family: Microsoft YaHei-Light;
      font-weight: 400;
      color: #666666;

      span {
        font-family: Microsoft YaHei-Light;
        font-weight: 400;
        color: #b4251e;
      }
    }

    .tips {
      font-family: Microsoft YaHei-Light;
      font-weight: 400;
      color: #999999;
      padding-top: 16px;
    }

    .accept {
      font-family: Microsoft YaHei-Light;
      font-weight: 400;

      color: #666666;
      padding-top: 16px;

      .checkbox {
        width: 14px;
        height: 14px;
        background: #ffffff;
        opacity: 1;
        border: 1px solid #b4251e;
        border-radius: 50%;
        margin-right: 8px;

        .dot {
          width: 6px;
          height: 6px;
          background: #b4251e;
          opacity: 1;
          border: 1px solid #b4251e;
          border-radius: 50%;
        }
      }

      .un-checked {
        width: 14px;
        height: 14px;
        margin-right: 8px;
      }
    }

    .btn-box {
      padding-top: 16px;

      .cancel-btn {
        width: 130px;
        height: 40px;
        background: rgba(180, 37, 30, 0.1);
        opacity: 1;
        border: 1px solid #b4251e;
        color: #b4251e;
      }

      .accept-btn {
        width: 130px;
        height: 40px;
        background: #b4251e;
        color: #ffffff;
        opacity: 1;
        margin-left: 30px;
      }
    }
  }
}

@media (max-width: 992px) {
  .accept-container {
    padding: 56px 40px;
    background: #ffffff url("../../assets/images/recommend/leftbg.png")
      no-repeat left bottom;
    background-size: 300px 200px;
    z-index: $z-index-foot;
    position: absolute;
    top: 0;
    right: 120px;
    width: 576px;
    height: 508px;
    opacity: 1;
    border: 1px solid;
    border-image: linear-gradient(
        164deg,
        rgba(239, 239, 239, 1),
        rgba(235, 235, 235, 0)
      )
      1 1;
    filter: blur(undefinedpx);
    font-size: 24px;

    .agree-mobile {
      display: block;
      padding-bottom: 0;
    }

    .title {
      font-family: Microsoft YaHei-Light;
      font-weight: 400;
      color: #666666;

      span {
        font-family: Microsoft YaHei-Light;
        font-weight: 400;
        color: #b4251e;
      }
    }

    .tips {
      font-family: Microsoft YaHei-Light;
      font-weight: 400;
      color: #999999;
      padding-top: 16px;
    }

    .accept {
      font-family: Microsoft YaHei-Light;
      font-weight: 400;

      color: #666666;
      padding-top: 16px;

      .checkbox {
        width: 20px;
        height: 20px;
        background: #ffffff;
        border: 1px solid #b4251e;
        border-radius: 50%;
        margin-right: 8px;

        .dot {
          width: 8px;
          height: 8px;
          background: #b4251e;
          opacity: 1;
          border: 1px solid #b4251e;
          border-radius: 50%;
        }
      }

      .un-checked {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }

    .btn-box {
      padding-top: 40px;

      .cancel-btn {
        width: 180px;
        height: 60px;
        background: rgba(180, 37, 30, 0.1);
        opacity: 1;
        border: 1px solid #b4251e;
        color: #b4251e;
      }

      .accept-btn {
        width: 180px;
        height: 60px;
        background: #b4251e;
        color: #ffffff;
        opacity: 1;
        margin-left: 30px;
      }
    }
  }
}
</style>
